"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const formik_1 = require("formik");
const rambda_1 = require("rambda");
const FormProvider = ({ children, formikRef, defaultValues, onSubmit }) => {
    return ((0, jsx_runtime_1.jsx)(formik_1.Formik, { innerRef: formikRef, onSubmit: async (values, { setSubmitting, validateForm }) => {
            const errors = await validateForm(values);
            if ((0, rambda_1.isEmpty)(errors)) {
                setSubmitting(false);
                if (onSubmit)
                    return onSubmit(values);
            }
        }, initialValues: defaultValues, validateOnChange: true, validate: props => {
            const errors = {};
            return errors;
        }, children: formik => ((0, jsx_runtime_1.jsx)(formik_1.Form, { children: (0, jsx_runtime_1.jsx)("div", { children: children({
                    submit: formik.submitForm,
                    reset: formik.resetForm,
                    formik: formik,
                }) }) })) }));
};
exports.FormProvider = FormProvider;
